import {NgModule} from '@angular/core';
import {LifeCertificationService} from './life-certification.service';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    providers: [LifeCertificationService]
})
export class LifeCertificationModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/lifecertification/life-certification.module.ts